export default function(keyMap) {
    this.setOption('keyMap', keyMap);
}
